/**
 * Clipping Service
 * 클리핑 관련 API 호출을 담당하는 서비스
 */

import { apiClient } from '@/lib/api-client';
import type { ApiResponse } from '@/lib/types/api';
import type {
  WeeklyClippingResponse,
  ClippingPageResponse,
} from '@/types/report';

class ClippingService {
  /**
   * 주간 클리핑 조회
   * GET /clippings/weekly
   */
  async getWeeklyClipping(): Promise<ApiResponse<WeeklyClippingResponse>> {
    return apiClient.get<WeeklyClippingResponse>('/clippings/weekly');
  }

  /**
   * 클리핑 페이징 조회
   * GET /clippings/page
   */
  async getClippingPage(
    page: number = 1,
    size: number = 12
  ): Promise<ApiResponse<ClippingPageResponse>> {
    return apiClient.get<ClippingPageResponse>(
      `/clippings/page?page=${page}&size=${size}`
    );
  }
}

// 싱글톤 인스턴스 export
export const clippingService = new ClippingService();

